export default "__VITE_ASSET__dd89bd3b__"